import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';

import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { RenderableStory } from '../../types/story-reading.types.ts';

import {
  KeyWordIndices,
  KeyWordPositionUpdatePayload,
  STORY_READING_SLICE_NAME,
  StoryReadingSliceState,
} from './story-reading.slice.types.ts';
import { computeStepWordIndicesThunkExtraReducers } from './thunks/compute-step-word-indices.thunk.ts';

export const STORY_READING_SLICE_INITIAL_STATE: StoryReadingSliceState = {
  currentStory: undefined,
  currentLine: undefined,
  keyWordPositions: {},
  keyWordIndices: {},
};

const persistKeys: (keyof StoryReadingSliceState)[] = [];

const persistConfig: PersistConfig<StoryReadingSliceState> = {
  key: STORY_READING_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: persistKeys,
};

const storyReadingSlice = createSlice({
  name: STORY_READING_SLICE_NAME,
  initialState: STORY_READING_SLICE_INITIAL_STATE,
  reducers: {
    resetStoryReadingSlice: () => {
      return STORY_READING_SLICE_INITIAL_STATE;
    },
    setCurrentStory: (state, action: PayloadAction<RenderableStory>) => {
      state.currentStory = action.payload;
    },
    setCurrentLine: (state, action: PayloadAction<number>) => {
      state.currentLine = action.payload;
    },
    updateKeyWordPosition: (state, action: PayloadAction<KeyWordPositionUpdatePayload>) => {
      const { type, position } = action.payload;
      state.keyWordPositions[type] = position;
    },
    setKeyWordIndices: (state, action: PayloadAction<KeyWordIndices | undefined>) => {
      state.keyWordIndices = action.payload ?? {};
    },
  },
  extraReducers: (builder) => {
    computeStepWordIndicesThunkExtraReducers(builder);
  },
});

export const { resetStoryReadingSlice, setCurrentStory, setCurrentLine, updateKeyWordPosition, setKeyWordIndices } =
  storyReadingSlice.actions;

export const StoryReadingSlice = persistReducer(persistConfig, storyReadingSlice.reducer);
